"use strict";

var _regeneratorRuntime = require("/Users/JamesMontes/Documents/MobileApps/majocobos/majocobos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Users/JamesMontes/Documents/MobileApps/majocobos/majocobos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/Users/JamesMontes/Documents/MobileApps/majocobos/majocobos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/Users/JamesMontes/Documents/MobileApps/majocobos/majocobos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/JamesMontes/Documents/MobileApps/majocobos/majocobos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var Canvas_1 = require("./Canvas");

var Particles_1 = require("./Particles");

var Retina_1 = require("./Retina");

var FrameManager_1 = require("./FrameManager");

var Options_1 = require("../Options/Classes/Options");

var Utils_1 = require("../Utils");

var Container = /*#__PURE__*/function () {
  function Container(id, sourceOptions) {
    var _this = this;

    _classCallCheck(this, Container);

    this.id = id;
    this.sourceOptions = sourceOptions;
    this.firstStart = true;
    this.started = false;
    this.destroyed = false;
    this.paused = true;
    this.lastFrameTime = 0;
    this.pageHidden = false;
    this.retina = new Retina_1.Retina(this);
    this.canvas = new Canvas_1.Canvas(this);
    this.particles = new Particles_1.Particles(this);
    this.drawer = new FrameManager_1.FrameManager(this);
    this.noise = {
      generate: function generate() {
        return {
          angle: Math.random() * Math.PI * 2,
          length: Math.random()
        };
      },
      init: function init() {},
      update: function update() {}
    };
    this.interactivity = {
      mouse: {
        clicking: false,
        inside: false
      }
    };
    this.bubble = {};
    this.repulse = {
      particles: []
    };
    this.attract = {
      particles: []
    };
    this.plugins = new Map();
    this.drawers = new Map();
    this.density = 1;
    this.options = new Options_1.Options();

    for (var _len = arguments.length, presets = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      presets[_key - 2] = arguments[_key];
    }

    for (var _i = 0, _presets = presets; _i < _presets.length; _i++) {
      var preset = _presets[_i];
      this.options.load(Utils_1.Plugins.getPreset(preset));
    }

    var shapes = Utils_1.Plugins.getSupportedShapes();

    var _iterator = _createForOfIteratorHelper(shapes),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var type = _step.value;
        var drawer = Utils_1.Plugins.getShapeDrawer(type);

        if (drawer) {
          this.drawers.set(type, drawer);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (this.sourceOptions) {
      this.options.load(this.sourceOptions);
    }

    this.fpsLimit = this.options.fpsLimit > 0 ? this.options.fpsLimit : 60;
    this.options.setTheme(undefined);
    this.eventListeners = new Utils_1.EventListeners(this);

    if (typeof IntersectionObserver !== "undefined" && IntersectionObserver) {
      this.intersectionObserver = new IntersectionObserver(function (entries) {
        return _this.intersectionManager(entries);
      });
    }
  }

  _createClass(Container, [{
    key: "play",
    value: function play(force) {
      var needsUpdate = this.paused || force;

      if (this.firstStart && !this.options.autoPlay) {
        this.firstStart = false;
        return;
      }

      if (this.paused) {
        this.paused = false;
      }

      if (needsUpdate) {
        var _iterator2 = _createForOfIteratorHelper(this.plugins),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _step2$value = _slicedToArray(_step2.value, 2),
                plugin = _step2$value[1];

            if (plugin.play) {
              plugin.play();
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        this.lastFrameTime = performance.now();
      }

      this.draw();
    }
  }, {
    key: "pause",
    value: function pause() {
      if (this.drawAnimationFrame !== undefined) {
        Utils_1.Utils.cancelAnimation(this.drawAnimationFrame);
        delete this.drawAnimationFrame;
      }

      if (this.paused) {
        return;
      }

      var _iterator3 = _createForOfIteratorHelper(this.plugins),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _slicedToArray(_step3.value, 2),
              plugin = _step3$value[1];

          if (plugin.pause) {
            plugin.pause();
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      if (!this.pageHidden) {
        this.paused = true;
      }
    }
  }, {
    key: "draw",
    value: function draw() {
      var _this2 = this;

      this.drawAnimationFrame = Utils_1.Utils.animate(function (timestamp) {
        return _this2.drawer.nextFrame(timestamp);
      });
    }
  }, {
    key: "getAnimationStatus",
    value: function getAnimationStatus() {
      return !this.paused;
    }
  }, {
    key: "setNoise",
    value: function setNoise(noiseOrGenerator, init, update) {
      if (!noiseOrGenerator) {
        return;
      }

      if (typeof noiseOrGenerator === "function") {
        this.noise.generate = noiseOrGenerator;

        if (init) {
          this.noise.init = init;
        }

        if (update) {
          this.noise.update = update;
        }
      } else {
        if (noiseOrGenerator.generate) {
          this.noise.generate = noiseOrGenerator.generate;
        }

        if (noiseOrGenerator.init) {
          this.noise.init = noiseOrGenerator.init;
        }

        if (noiseOrGenerator.update) {
          this.noise.update = noiseOrGenerator.update;
        }
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.stop();
      this.canvas.destroy();

      var _iterator4 = _createForOfIteratorHelper(this.drawers),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _step4$value = _slicedToArray(_step4.value, 2),
              drawer = _step4$value[1];

          if (drawer.destroy) {
            drawer.destroy(this);
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      var _iterator5 = _createForOfIteratorHelper(this.drawers.keys()),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var key = _step5.value;
          this.drawers.delete(key);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      this.destroyed = true;
    }
  }, {
    key: "exportImg",
    value: function exportImg(callback) {
      this.exportImage(callback);
    }
  }, {
    key: "exportImage",
    value: function exportImage(callback, type, quality) {
      var _a;

      return (_a = this.canvas.element) === null || _a === void 0 ? void 0 : _a.toBlob(callback, type !== null && type !== void 0 ? type : "image/png", quality);
    }
  }, {
    key: "exportConfiguration",
    value: function exportConfiguration() {
      return JSON.stringify(this.options, undefined, 2);
    }
  }, {
    key: "refresh",
    value: function refresh() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.stop();
                _context.next = 3;
                return this.start();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!this.started) {
        return;
      }

      this.firstStart = true;
      this.started = false;
      this.eventListeners.removeListeners();
      this.pause();
      this.particles.clear();
      this.canvas.clear();

      if (this.interactivity.element instanceof HTMLElement && this.intersectionObserver) {
        this.intersectionObserver.observe(this.interactivity.element);
      }

      var _iterator6 = _createForOfIteratorHelper(this.plugins),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _step6$value = _slicedToArray(_step6.value, 2),
              plugin = _step6$value[1];

          if (plugin.stop) {
            plugin.stop();
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      var _iterator7 = _createForOfIteratorHelper(this.plugins.keys()),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var key = _step7.value;
          this.plugins.delete(key);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      this.particles.linksColors = new Map();
      delete this.particles.grabLineColor;
      delete this.particles.linksColor;
    }
  }, {
    key: "loadTheme",
    value: function loadTheme(name) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.options.setTheme(name);
                _context2.next = 3;
                return this.refresh();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "start",
    value: function start() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _iterator8, _step8, _step8$value, plugin;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.started) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                _context3.next = 4;
                return this.init();

              case 4:
                this.started = true;
                this.eventListeners.addListeners();

                if (this.interactivity.element instanceof HTMLElement && this.intersectionObserver) {
                  this.intersectionObserver.observe(this.interactivity.element);
                }

                _iterator8 = _createForOfIteratorHelper(this.plugins);
                _context3.prev = 8;

                _iterator8.s();

              case 10:
                if ((_step8 = _iterator8.n()).done) {
                  _context3.next = 20;
                  break;
                }

                _step8$value = _slicedToArray(_step8.value, 2), plugin = _step8$value[1];

                if (!(plugin.startAsync !== undefined)) {
                  _context3.next = 17;
                  break;
                }

                _context3.next = 15;
                return plugin.startAsync();

              case 15:
                _context3.next = 18;
                break;

              case 17:
                if (plugin.start !== undefined) {
                  plugin.start();
                }

              case 18:
                _context3.next = 10;
                break;

              case 20:
                _context3.next = 25;
                break;

              case 22:
                _context3.prev = 22;
                _context3.t0 = _context3["catch"](8);

                _iterator8.e(_context3.t0);

              case 25:
                _context3.prev = 25;

                _iterator8.f();

                return _context3.finish(25);

              case 28:
                this.play();

              case 29:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[8, 22, 25, 28]]);
      }));
    }
  }, {
    key: "init",
    value: function init() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var availablePlugins, _iterator9, _step9, _step9$value, id, plugin, _iterator10, _step10, _step10$value, drawer, _iterator11, _step11, _step11$value, _plugin;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.retina.init();
                this.canvas.init();
                this.fpsLimit = this.options.fpsLimit > 0 ? this.options.fpsLimit : 60;
                availablePlugins = Utils_1.Plugins.getAvailablePlugins(this);
                _iterator9 = _createForOfIteratorHelper(availablePlugins);

                try {
                  for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                    _step9$value = _slicedToArray(_step9.value, 2), id = _step9$value[0], plugin = _step9$value[1];
                    this.plugins.set(id, plugin);
                  }
                } catch (err) {
                  _iterator9.e(err);
                } finally {
                  _iterator9.f();
                }

                _iterator10 = _createForOfIteratorHelper(this.drawers);
                _context4.prev = 7;

                _iterator10.s();

              case 9:
                if ((_step10 = _iterator10.n()).done) {
                  _context4.next = 16;
                  break;
                }

                _step10$value = _slicedToArray(_step10.value, 2), drawer = _step10$value[1];

                if (!drawer.init) {
                  _context4.next = 14;
                  break;
                }

                _context4.next = 14;
                return drawer.init(this);

              case 14:
                _context4.next = 9;
                break;

              case 16:
                _context4.next = 21;
                break;

              case 18:
                _context4.prev = 18;
                _context4.t0 = _context4["catch"](7);

                _iterator10.e(_context4.t0);

              case 21:
                _context4.prev = 21;

                _iterator10.f();

                return _context4.finish(21);

              case 24:
                _iterator11 = _createForOfIteratorHelper(this.plugins);
                _context4.prev = 25;

                _iterator11.s();

              case 27:
                if ((_step11 = _iterator11.n()).done) {
                  _context4.next = 38;
                  break;
                }

                _step11$value = _slicedToArray(_step11.value, 2), _plugin = _step11$value[1];

                if (!_plugin.init) {
                  _context4.next = 33;
                  break;
                }

                _plugin.init(this.options);

                _context4.next = 36;
                break;

              case 33:
                if (!(_plugin.initAsync !== undefined)) {
                  _context4.next = 36;
                  break;
                }

                _context4.next = 36;
                return _plugin.initAsync(this.options);

              case 36:
                _context4.next = 27;
                break;

              case 38:
                _context4.next = 43;
                break;

              case 40:
                _context4.prev = 40;
                _context4.t1 = _context4["catch"](25);

                _iterator11.e(_context4.t1);

              case 43:
                _context4.prev = 43;

                _iterator11.f();

                return _context4.finish(43);

              case 46:
                this.canvas.initSize();
                this.particles.init();
                this.particles.setDensity();

              case 49:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[7, 18, 21, 24], [25, 40, 43, 46]]);
      }));
    }
  }, {
    key: "intersectionManager",
    value: function intersectionManager(entries) {
      if (!this.options.pauseOnOutsideViewport) {
        return;
      }

      var _iterator12 = _createForOfIteratorHelper(entries),
          _step12;

      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var entry = _step12.value;

          if (entry.target !== this.interactivity.element) {
            continue;
          }

          if (entry.isIntersecting) {
            this.play();
          } else {
            this.pause();
          }
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
    }
  }]);

  return Container;
}();

exports.Container = Container;